import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { EditExercisePage } from './edit-exercise-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [EditExercisePage],
    imports: [PagesModule, ComponentsModule, DirectivesModule]
})
export class EditExercisePageModule { }
